import React from 'react';

const InformasiPage = () => {
    const informasiList = [
        { id: 1, judul: "Pengumuman Jadwal Pelayanan", tanggal: "2024-01-15", kategori: "Pengumuman" },
        { id: 2, judul: "Perubahan Tarif Retribusi 2024", tanggal: "2024-01-10", kategori: "Kebijakan" },
        { id: 3, judul: "Sosialisasi e-Retribusi", tanggal: "2024-01-05", kategori: "Sosialisasi" },
    ];

    return (
        <div className="container mx-auto px-4 py-12">
            <h1 className="text-3xl font-bold text-[#1E3A8A] mb-8">Informasi</h1>

            <div className="space-y-4">
                {informasiList.map((info) => (
                    <div key={info.id} className="card-glass flex items-center justify-between">
                        <div>
                            <span className="text-sm bg-[#0D9488] text-white px-3 py-1 rounded-full">
                                {info.kategori}
                            </span>
                            <h3 className="text-lg font-semibold text-[#1E3A8A] mt-2">{info.judul}</h3>
                            <p className="text-sm text-gray-500 mt-1">{info.tanggal}</p>
                        </div>
                        <button className="btn-primary">Detail</button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default InformasiPage;